import { WithoutPermissionGuard } from '@app/guards/without-permisson-guard.service';
import { AdminGuard } from './admin.guard';
import { AuthGuard } from './auth.guard';
import { CompanyAttributeGuard } from './company-attribute.guard';
import { CompanyModuleGuard } from './company-module.guard';
import { EmployeeAccessGuard } from './employee-access-guard';
import { EmployeeModuleGuard } from './employee-module.guard';
import { EmployeeGuard } from './employee.guard';
import { ExternalUrlRedirectGuard } from './external-url-redirect.guard';
import {
    DoesntHaveFeatureRedirectGuard,
    FeatureGuard,
    HasFeatureRedirectGuard,
    HasKycKybRedirectGuard,
    KycKybDoesntHaveRedirectGuard,
    KycKybFeatureGuard,
} from './feature-guards';
import { GuestGuard } from './guest.guard';
import { KYCKYBPermissionGuard } from './kyc-kyb-permission.guard';
import { ModulesGuard } from './modules.guard';
import { NavigationGuard } from './navigation.guard';
import { PermissionGuard } from './permission.guard';

const Guards = [
    AdminGuard,
    AuthGuard,
    DoesntHaveFeatureRedirectGuard,
    EmployeeGuard,
    EmployeeModuleGuard,
    FeatureGuard,
    GuestGuard,
    HasFeatureRedirectGuard,
    KycKybDoesntHaveRedirectGuard,
    KycKybFeatureGuard,
    HasKycKybRedirectGuard,
    ModulesGuard,
    NavigationGuard,
    PermissionGuard,
    KYCKYBPermissionGuard,
    WithoutPermissionGuard,
    EmployeeAccessGuard,
    ExternalUrlRedirectGuard,
    CompanyModuleGuard,
    CompanyAttributeGuard,
];

export {
    AdminGuard,
    AuthGuard,
    CompanyAttributeGuard,
    CompanyModuleGuard,
    DoesntHaveFeatureRedirectGuard,
    EmployeeAccessGuard,
    EmployeeGuard,
    EmployeeModuleGuard,
    ExternalUrlRedirectGuard,
    FeatureGuard,
    Guards,
    GuestGuard,
    HasFeatureRedirectGuard,
    KycKybDoesntHaveRedirectGuard,
    KycKybFeatureGuard,
    HasKycKybRedirectGuard as KycKybHasRedirectGuard,
    KYCKYBPermissionGuard,
    ModulesGuard,
    NavigationGuard,
    PermissionGuard,
    WithoutPermissionGuard,
};
